import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, CircularProgress, Alert,
} from '@mui/material';
import { InvTextField } from '../InvField';
import { unsealRfq } from '../../api/rfq';
import { IPD_COLORS, cardSx } from '../../theme';

const MIN_REASON_CHARS = 10;

export default function RfqUnsealDialog({ open, rfq, onClose, onSuccess }) {
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const tooShort = reason.trim().length < MIN_REASON_CHARS;

  async function handleSubmit() {
    if (tooShort) return;
    setLoading(true);
    setError(null);
    try {
      await unsealRfq(rfq.id || rfq.rfq_id, reason.trim());
      onSuccess?.();
      onClose?.();
    } catch (e) {
      setError(e.message || 'Could not unseal this RFQ');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="sm" fullWidth
      PaperProps={{ sx: cardSx }}>
      <DialogTitle sx={{ color: IPD_COLORS.textPrimary }}>Unseal rates early</DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          This RFQ was set up as a sealed bid, so rates were meant to stay hidden until
          the deadline. Unsealing now is permanent and is recorded against the RFQ with
          your reason.
        </Alert>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <InvTextField
          label="Reason for unsealing early"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          multiline
          rows={3}
          error={Boolean(reason) && tooShort}
          helperText={`At least ${MIN_REASON_CHARS} characters — ${reason.trim().length} so far.`}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button onClick={onClose} disabled={loading} variant="outlined"
          sx={{ color: IPD_COLORS.textSecondary, borderColor: IPD_COLORS.border }}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} disabled={loading || tooShort} variant="contained"
          sx={{ backgroundColor: IPD_COLORS.primary }}
          startIcon={loading ? <CircularProgress size={16} sx={{ color: '#fff' }} /> : null}>
          Unseal rates
        </Button>
      </DialogActions>
    </Dialog>
  );
}
